import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import moment from "moment";
import { ComprasService } from "../../services/compras.service";
import { CommonModule } from "@angular/common";
import {
  CashbackService,
  ReviewPurchaseAction,
} from "../../services/cashback.service";
import { ModalService } from "../../components/modal/service/modal.service";
import Swal from "sweetalert2";
import { CashbackFormComponent } from "../cashback/cashback-form/cashback-form.component";
import { Subscription } from "rxjs";

@Component({
  selector: "app-compras",
  templateUrl: "./compras.component.html",
  styleUrls: ["./compras.component.scss"],
  imports: [CommonModule],
})
export class CheckInsComponent implements OnInit, OnDestroy {
  public checkins: any = [];
  public recentCheckin: any = [];
  public recentDataCheckin: any;
  loading = false;
  error: string | null = null;
  private actionSubscription: Subscription | undefined;

  constructor(
    @Inject(ComprasService) private comprasService: ComprasService,
    @Inject(CashbackService) public cashbackService: CashbackService,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.getCompras();
    this.actionSubscription = this.cashbackService.action$.subscribe(() => {
      this.getCompras();
    });
  }

  ngOnDestroy() {
    if (this.actionSubscription) {
      this.actionSubscription.unsubscribe();
    }
  }

  getCompras() {
    this.loading = true;
    this.error = null;

    this.comprasService.getCompras().subscribe({
      next: (res) => {
        this.loading = false;
        const realDateNow = new Date(Date.now());
        const recentDate = moment(realDateNow).format("YYYY-MM-DD");
        const lastCheckInFilter = res.filter(
          (x: any) => x.date === recentDate.toString()
        );
        this.checkins = res;
        this.recentCheckin =
          lastCheckInFilter.length > 0 ? lastCheckInFilter[0] : res[0];
      },
      error: (error) => {
        this.loading = false;
        this.error = "Erro ao carregar compras";
        console.error("Erro ao carregar compras:", error);
      },
    });
  }

  async verImagem(image: string) {
    if (!image) {
      Swal.fire({
        title: "Aviso",
        text: "Nenhuma imagem disponível",
        icon: "info",
      });
      return;
    }

    this.modalService.openModal(
      CashbackFormComponent,
      "Exibir comprovante",
      "modal-md",
      { image }
    );
  }

  trackByFn(index: number, item: any): any {
    return item?.id || index;
  }

  async aprovar(id: string) {
    await this.revisar(id, "approve");
  }

  async rejeitar(id: string) {
    await this.revisar(id, "reject");
  }

  private async revisar(id: string, action: ReviewPurchaseAction) {
    if (!id) return;

    const isApprove = action === "approve";
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: isApprove ? "btn btn-success" : "btn btn-danger",
        cancelButton: "btn btn-secondary",
      },
      buttonsStyling: false,
    });

    const result = await swalWithBootstrapButtons.fire({
      title: isApprove ? "Aprovar Cashback" : "Rejeitar Cashback",
      text: isApprove
        ? "Deseja realmente aprovar este cashback?"
        : "Deseja realmente rejeitar este cashback? O saldo reservado será estornado.",
      icon: isApprove ? "question" : "warning",
      showCancelButton: true,
      confirmButtonText: isApprove ? "Sim, aprovar!" : "Sim, rejeitar!",
      cancelButtonText: "Cancelar",
      reverseButtons: false,
    });

    if (!result.isConfirmed) return;

    try {
      await this.cashbackService.reviewPurchase(id, action);

      Swal.fire({
        title: isApprove ? "Aprovado!" : "Rejeitado!",
        text: isApprove
          ? "Cashback aprovado com sucesso."
          : "Cashback rejeitado com sucesso.",
        icon: "success",
      });
    } catch (error) {
      console.error(`Erro ao ${action} cashback:`, error);
      Swal.fire({
        title: "Erro!",
        text: isApprove
          ? "Erro ao aprovar cashback."
          : "Erro ao rejeitar cashback.",
        icon: "error",
      });
    }
  }
}
